import { Icon, Icons } from 'components/Icon';
import React from 'react';
import { Children } from 'service/dto/children.dto';

type Props = {
  childrens: Children;
  selectedIds: number[];
  onChange: (ids: number[]) => void;
};

export default function GuardianChildrenChecklist({
  childrens,
  selectedIds,
  onChange
}: Readonly<Props>) {
  const toggle = (id: number) => {
    onChange(
      selectedIds.includes(id)
        ? selectedIds.filter(selectedId => selectedId !== id)
        : [...selectedIds, id]
    );
  };

  return (
    <div className="flex w-full flex-col">
      <label className="mb-2 text-[12px] font-medium text-[#353535]">
        Assign to
      </label>
      <div className="flex flex-wrap gap-x-10 gap-y-3">
        {childrens.map(child => (
          <button
            key={child.id}
            type="button"
            onClick={() => toggle(child.id!)}
            className="flex items-center gap-3"
          >
            <span className="text-base font-bold text-[#353535]">
              {[
                child.childFirstName,
                child.childMiddleName,
                child.childLastName
              ]
                .filter(Boolean)
                .join(' ')}
            </span>
            <Icon
              name={
                selectedIds.includes(child.id!)
                  ? Icons.CheckedBox
                  : Icons.UncheckBox
              }
            />
          </button>
        ))}
      </div>
      {!selectedIds.length && (
        <p className="mt-2 text-xs text-red-600">
          Please select at least one child
        </p>
      )}
    </div>
  );
}
